import css from './queueControl.module.scss';

import { memo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useHistoryModal } from 'com/HistoryModal';
import NSFWMenuItem from 'com/NSFW/NSFWMenuItem';
import { getDeckUrl } from 'core/paths';
import Button from 'core/ui/Button';
import { Menu, MenuItem } from 'core/ui/Menu';
import ICONS, { Icon } from 'core/ui/icons';

import AutoSpeechToggler from './AutoSpeechToggler';
import EditButton from './EditButton';
import PostponeButton from './PostponeButton';
import UndoButton from './UndoButton';

type TProps = {
  pos: number;
  count: number;
  finish: () => void;
  undo: TUndo | null;
  setUndo: (undo: null) => void;
  goNext: () => void;
  goPrev: () => void;
  wordUid: string;
  onUpdateWord: (word: TWord) => void;
  deck: TDeck;
  exercise: TExercise;
};

const WordQueueControl: React.FC<TProps> = ({
  pos,
  count,
  finish,
  undo,
  setUndo,
  goNext,
  goPrev,
  wordUid,
  onUpdateWord,
  deck,
  exercise,
}) => {
  const navigate = useNavigate();
  const { showWordHistory } = useHistoryModal();

  return (
    <div className={css.queueControl}>
      <div className={css.position}>{`${pos + 1} / ${count}`}</div>
      <div className={css.controls}>
        {undo && (
          <UndoButton
            undo={undo}
            setUndo={setUndo}
            onUpdateWord={onUpdateWord}
            goPrev={goPrev}
          />
        )}
        {deck.lang && <AutoSpeechToggler />}
        <Menu
          anchor={({ setRef, toggle }) => (
            <div
              className={css.button}
              title="Undo"
              ref={setRef}
              onClick={toggle}
              children={<Icon icon="Menu" />}
            />
          )}
        >
          <EditButton wordUid={wordUid} onUpdateWord={onUpdateWord} />
          <PostponeButton
            goNext={goNext}
            wordUid={wordUid}
            onUpdateWord={onUpdateWord}
            exercise={exercise}
          />
          <MenuItem
            label="Show status"
            icon={ICONS.Graph}
            onClick={() => showWordHistory(wordUid)}
            kkb="F3"
          />
          <MenuItem
            label="Show all cards"
            icon={ICONS.Cards}
            onClick={() => void navigate(getDeckUrl(deck.uid))}
          />
          <NSFWMenuItem />
        </Menu>
        <Button
          children={pos >= count - 1 ? 'finish' : 'close'}
          onClick={finish}
        />
      </div>
    </div>
  );
};

export default memo(WordQueueControl);
